export default string => {
  return string.replace(/[^A-Z0-9]/gi, ' ');
};
